/**
 * File utility functions for handling file conversions and transformations
 */

/**
 * Convert a File object to a base64 string
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const result = reader.result as string
      const base64Data = result.split(',')[1]
      resolve(base64Data)
    }
    reader.onerror = error => reject(error)
  })
}

/**
 * Convert a URL to a File object
 */
export const urlToFile = async (url: string, fileName: string): Promise<File> => {
  try {
    const response = await fetch(url)
    
    // Handle response with ReadableStream in body
    if (response.body) {
      const reader = response.body.getReader();
      const chunks: Uint8Array[] = [];
      
      // Read all chunks from the stream
      let done = false;
      while (!done) {
        const { done: isDone, value } = await reader.read();
        if (isDone) {
          done = true;
        } else if (value) {
          chunks.push(value);
        }
      }
      
      // Concatenate chunks into a single Uint8Array
      const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
      const uint8Array = new Uint8Array(totalLength);
      let position = 0;
      for (const chunk of chunks) {
        uint8Array.set(chunk, position);
        position += chunk.length;
      }
      
      // Create blob and file
      const blob = new Blob([uint8Array], { type: response.headers.get('content-type') || 'application/octet-stream' });
      return new File([blob], fileName, { type: blob.type });
    } else {
      // Fallback to blob() if body is not available
      const blob = await response.blob();
      return new File([blob], fileName, { type: blob.type });
    }
  } catch (error) {
    console.error('Error converting URL to File:', error)
    throw error
  }
}